/**
 * Configuration required for Amplify.
 * Ref: https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
 */

export const envConfig = {
    Auth: {
        // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
        identityPoolId: 'us-east-1:29e0137e-28c0-4de7-b020-ed5426bd9ba6',

        // (required)- Amazon Cognito Region
        region: 'us-east-1',

        // (optional) - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_BRcmao5dM',

        // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
        userPoolWebClientId: '7t4d9k0f6r1nqmongdo6gvneuu',

        // (optional) - Enforce user authentication prior to accessing AWS resources or not
        mandatorySignIn: true,

        // (optional) - Hosted UI configuration
        oauth: {
            domain: 'controllershiphub-dev-yyalex' + '.auth.us-east-1.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            //  redirectSignIn: 'http://localhost:4321/',
            //  redirectSignOut: 'http://localhost:4321/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
};